var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.items.name)+" ("+_vm._s(_vm.items.info.length)+")")]),_c('div',_vm._l((_vm.items.info),function(item,index){return _c('goods',{key:index,attrs:{"data":item}})}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }